/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Row } from "components/styles";
import CustomButton from "components/CustomButton/CustomButton";
import { FOOTER_BUTTON_DEFAULT_PROPS } from "./utils/constants";
import { Container } from "./styles";

const Footer = ({
    formHandler: {
        form, errors
    },
    saveChanges, openDialogConfirmDelete,
    getDisabledSaveButton,
    hideDialogSpaceForm
}) => {
    //#region States
    const [disabledSaveButton, setDisabledSaveButton] = useState(false);
    //#endregion
    //#region Effects
    useEffect(() => {
        setDisabledSaveButton(getDisabledSaveButton());
    }, [form.value, errors.value]);
    //#endregion
    return (
        <Container justify="space-between">
            <CustomButton
                {...FOOTER_BUTTON_DEFAULT_PROPS}
                variant="terciary"
                text="Eliminar"
                onClick={openDialogConfirmDelete} />
            <Row>
                <CustomButton
                    {...FOOTER_BUTTON_DEFAULT_PROPS}
                    variant="secondary"
                    text="Cancelar"
                    onClick={hideDialogSpaceForm} />
                <CustomButton
                    {...FOOTER_BUTTON_DEFAULT_PROPS}
                    text="Guardar"
                    onClick={saveChanges}
                    disabled={disabledSaveButton} />
            </Row>
        </Container>
    );
}

export default Footer;